
import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { classNames } from "primereact/utils";
import { usePresentacionContext } from "../context/presentacion.context";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { ImpuestosDTOAdapter, impuestosDTOAdapterEmpty, impuestosPresentacionRequestUpdateAdapter } from "../adapters/impuesto.adapter";
import { InputNumber } from "primereact/inputnumber";
import {
  actualizarImpuestosPredeterminados,
  actualizarImpuestosPresentacion,
  consultarImpuestosPresentacion,
  crearImpuestosPredeterminados,
} from "../services/impuestos.service";

import {IMPUESTO_DECLARADO} from "../utilities/constants";


const ImpuestosTasasForm = () => {
  const {
    impuestoTasaSeleccionado,
    setOnHideDialog,
    setDataImpuestos,
    presentacion,
    setShowToastImpuestoTasaVerificado,
    showToastImpuestoTasaVerificado,
    setImpuestoTasaSeleccionado
  } = usePresentacionContext();
  const toast = useRef<Toast>(null);

  const formik = useFormik({
    initialValues: {
      IdServicio: impuestoTasaSeleccionado.idServicio,
      ServicioXBandera: impuestoTasaSeleccionado.servicioXBandera,
      Litros: impuestoTasaSeleccionado.litros,
      ItC_precio: impuestoTasaSeleccionado.precioITC,
      IdC_precio: impuestoTasaSeleccionado.precioIDC,
      Tasa_municipal_precio: impuestoTasaSeleccionado.precioTasaMunicipal,
      Tasa_hidrica_precio: impuestoTasaSeleccionado.precioTasaHidrica,
      ItC_total: impuestoTasaSeleccionado.totalITC,
      PreCupon: impuestoTasaSeleccionado.preCupon,
      Verificado: impuestoTasaSeleccionado.declarado,
      recordarParaFuturasPresentaciones: true,
      impuestoPredeterminado:impuestoTasaSeleccionado.impuestoPredeterminado
    },
    
    validate: (data) => {
      let errors: any = {};
      if (!data.ServicioXBandera) {
        errors.ServicioXBandera = "Requerido.";
      }

      if (!data.Litros) {
        errors.Litros = "Requerido.";
      }
      
      if (data.ItC_precio === undefined || data.ItC_precio === null ) {
          errors.ItC_precio = "Requerido.";
      }
      
      if(data.IdC_precio === undefined || data.IdC_precio === null){
          errors.IdC_precio = "Requerido.";
      }

      if (data.Tasa_municipal_precio === undefined || data.Tasa_municipal_precio === null) {
        errors.Tasa_municipal_precio = "Requerido.";
      }

      if (data.Tasa_hidrica_precio === undefined || data.Tasa_hidrica_precio === null) {
        errors.Tasa_hidrica_precio = "Requerido.";
      }


      return errors;
    },
    onSubmit: async (data) => {
      data.Verificado = IMPUESTO_DECLARADO;
      let impuestosPresentacionAdapter = impuestosPresentacionRequestUpdateAdapter(data,[])
      impuestosPresentacionAdapter.ListaImpuestos.push(impuestosDTOAdapterEmpty())
      if(data.recordarParaFuturasPresentaciones){
        if(data.impuestoPredeterminado){
          //update
          let resultActualizarImpPre = await actualizarImpuestosPredeterminados(impuestosPresentacionAdapter)
          if(resultActualizarImpPre.status !== 200){
            //mostrar error
          }
  
        }else{
          //create
          let impuestosDTOAdapter = ImpuestosDTOAdapter(data)
          impuestosPresentacionAdapter = impuestosPresentacionRequestUpdateAdapter(data,[])
          impuestosPresentacionAdapter.ListaImpuestos.push(impuestosDTOAdapter);
          //check true creo imp predeterminado
          if(data.recordarParaFuturasPresentaciones){
            let resultCrearImpPre =  await crearImpuestosPredeterminados(impuestosPresentacionAdapter)
            if(resultCrearImpPre.status === 200){
    
            }
          }
        }
      }
      
      let result = await actualizarImpuestosPresentacion(impuestosPresentacionAdapter);
      
      if (result.status === 200) {
        await getImpuestosApi();
        formik.resetForm();
      }
    },
  });
  const handleBlur = (name:string, e:any) =>{
    let totalFormat = Number(parseFloat(e.currentTarget.value ? e.currentTarget.value: 0)).toFixed(4); 
    formik.setFieldValue(name, totalFormat)
  }

  const getImpuestosApi = async () => {
    const {data, status} = await consultarImpuestosPresentacion(presentacion);
    if(status === 200){
      setDataImpuestos(data)
    }
    setOnHideDialog(false);
    setShowToastImpuestoTasaVerificado(showToastImpuestoTasaVerificado + 1)
  };

  const setOnHideDialog2 = () => {
    setImpuestoTasaSeleccionado({})
    setOnHideDialog(false);
    setShowToastImpuestoTasaVerificado(-1)
  };
  
  const formikTouched: any = formik.touched;
  const formikErrors: any = formik.errors;

  const isFormFieldValid = (name:string) =>
    !!(formikTouched[name] && formikErrors[name]);

  const getFormErrorMessage = (name:string) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formikErrors[name]}</small>
      )
    );
  };

  const setShowMessage2 = () => {
    setOnHideDialog(false);
  };
  const dialogFooter = (
    <div className="flex justify-content-center">
      <Button
        label="OK"
        className="p-button-text"
        autoFocus
        onClick={() => setShowMessage2()}
      />
    </div>
  );

  return (
    <div className="form-demo">
        <Toast ref={toast} position="bottom-right"/>
      <div className="flex justify-content-center">
        <form
          onSubmit={formik.handleSubmit}
          className="p-fluid "
        >

            <Card className="p-mb-2">
            <div className="p-grid p-fluid  p-align-baseline grid-datos-generales">
              <div className="p-col-12 p-md-6">
                <div className="field">
                    <span className="p-float-label">
                    <InputText
                        id="ServicioXBandera"
                        disabled={true}
                        name="ServicioXBandera"
                        value={formik.values.ServicioXBandera}
                        onChange={formik.handleChange}
                        autoFocus
                        className={classNames({
                        "p-invalid": isFormFieldValid("ServicioXBandera"),
                        })}
                    />
                    <label
                        htmlFor="ServicioXBandera"
                        className={classNames({
                        "p-error": isFormFieldValid("ServicioXBandera"),
                        })}
                    >
                        Producto*
                    </label>
                    </span>
                    {getFormErrorMessage("ServicioXBandera")}
                </div>
              </div>
              <div className="p-col-12 p-md-6">
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    id="Litros"
                    disabled={true}
                    name="Litros"
                    value={formik.values.Litros}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("Litros"),
                    })}
                  />
                  <label
                    htmlFor="Litros"
                    className={classNames({
                      "p-error": isFormFieldValid("Litros"),
                    })}
                  >
                    Litros*
                  </label>
                </span>
                {getFormErrorMessage("Litros")}
              </div>                
              </div>
            </div>

            <div className="p-grid p-fluid  p-align-baseline grid-datos-generales">
              <div className="p-col-12 p-md-6">
                <div className="field">
                    <span className="p-float-label">
                    <InputNumber 
                      id="ItC_precio"
                      name="ItC_precio" 
                      value={formik.values.ItC_precio}
                      onValueChange={(e) => formik.setFieldValue("ItC_precio",e.value)}
                      mode="decimal"
                      minFractionDigits={4}
                      min={0}
                      className={classNames({
                        "p-invalid": isFormFieldValid("ItC_precio"),
                        })}
                    />

                    <label
                        htmlFor="ItC_precio"
                        className={classNames({
                        "p-error": isFormFieldValid("ItC_precio"),
                        })}
                    >
                        ITC*
                    </label>
                    </span>
                    {getFormErrorMessage("ItC_precio")}
                </div>
              </div>
              <div className="p-col-12 p-md-6">
                <div className="field">
                    <span className="p-float-label">
                    <InputNumber 
                      id="IdC_precio"
                      name="IdC_precio"
                      value={formik.values.IdC_precio}
                      onValueChange={(e) => formik.setFieldValue("IdC_precio",e.value)}
                      mode="decimal"
                      minFractionDigits={4}
                      min={0}
                      className={classNames({
                        "p-invalid": isFormFieldValid("IdC_precio"),
                        })}
                        
                    />
                    <label
                        htmlFor="IdC_precio"
                        className={classNames({
                        "p-error": isFormFieldValid("IdC_precio"),
                        })}
                    >
                        IDC*
                    </label>
                    </span>
                    {getFormErrorMessage("IdC_precio")}
                </div>
              </div>
            </div>
           <div className="p-grid p-fluid  p-align-baseline grid-datos-generales">
                <div className="p-col-12 p-md-6">
                <div className="field">
                    <span className="p-float-label">
                    <InputNumber 
                      id="Tasa_municipal_precio"
                      name="Tasa_municipal_precio"
                      value={formik.values.Tasa_municipal_precio}
                      onValueChange={(e) => formik.setFieldValue("Tasa_municipal_precio",e.value)}
                      mode="decimal"
                      minFractionDigits={4}
                      min={0}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Tasa_municipal_precio"),
                        })}
                    />
                    <label
                        htmlFor="Tasa_municipal_precio"
                        className={classNames({
                        "p-error": isFormFieldValid("Tasa_municipal_precio"),
                        })}
                    >
                        Tasa municipal*
                    </label>
                    </span>
                    {getFormErrorMessage("Tasa_municipal_precio")}
                </div>
                </div>
                <div className="p-col-12 p-md-6">
                <div className="field">
                    <span className="p-float-label">
                    <InputNumber 
                      id="Tasa_hidrica_precio"
                      name="Tasa_hidrica_precio"
                      value={formik.values.Tasa_hidrica_precio}
                      onValueChange={(e) => formik.setFieldValue("Tasa_hidrica_precio",e.value)}
                      mode="decimal"
                      minFractionDigits={4}
                      min={0}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Tasa_hidrica_precio"),
                        })}
                    />
                    <label
                        htmlFor="Tasa_hidrica_precio"
                        className={classNames({
                        "p-error": isFormFieldValid("Tasa_hidrica_precio"),
                        })}
                    >
                        Otras Tasas*
                    </label>
                    </span>
                    {getFormErrorMessage("Tasa_hidrica_precio")}
                </div>
                </div>
                
            </div>
            
            <div className="p-grid p-fluid  p-align-baseline grid-datos-generales">
            <div className="p-col-12 ">
              {
                impuestoTasaSeleccionado.declarado == 0 && <Tag className="mr-2" severity="info" value="Los valores propuestos corresponden a los valores guardados en su última declaración."></Tag>
              }
            </div>
              
              <div className="p-col-12 ">
                  <div className="field-checkbox">
                      <Checkbox
                      inputId="recordarParaFuturasPresentaciones"
                      name="recordarParaFuturasPresentaciones"
                      checked={formik.values.recordarParaFuturasPresentaciones}
                      onChange={formik.handleChange}
                      className={
                          classNames({ "p-invalid": isFormFieldValid("recordarParaFuturasPresentaciones") }) +
                          " mr-2"
                      }
                      />
                      <label
                      htmlFor="recordarParaFuturasPresentaciones"
                      className={classNames({
                          "p-error": isFormFieldValid("recordarParaFuturasPresentaciones"),
                      })}
                      >
                      Recordar los valores declarados para futuras presentaciones
                      </label>
                  </div>
              </div>
              
              
            </div>
             
          </Card>
        
          <Divider />

          <div className="p-grid p-fluid  p-align-baseline p-jc-end">
            <div className="p-col-12 p-md-4">
                <div className="button-demo">
                    <div className="template">
                        <Button 
                        type="button"
                        className="delete p-0" 
                        aria-label="Delete"
                        onClick={() => setOnHideDialog2()}
                        >
                            <i className="pi pi-times px-2"></i>
                            <span className="px-3">Cancelar</span>
                        </Button>
                    </div>
                </div>
            </div>
            <div className="p-col-12 p-md-4">
                <div className="button-demo">
                    <div className="template">
                        <Button 
                        className="twitter p-0" 
                        aria-label="Twitter"
                        type="submit"
                        >
                            <i className="pi pi-check px-2"></i>
                            <span className="px-3">Guardar</span>
                        </Button>
                    </div>
                </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImpuestosTasasForm;
